// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import ElementUI from 'element-ui';
import axios from 'axios';
import 'element-ui/lib/theme-chalk/index.css';
import 'babel-polyfill'
import {
  Message
}
from 'element-ui';


Vue.use(ElementUI)

Vue.config.productionTip = false;
Vue.http = Vue.prototype.$http = axios;
Vue.config.productionTip = false;
Vue.prototype.$message = Message;

Vue.http.interceptors.request.use(function (config) {
  let token = localStorage.getItem('authorization');
  if (token) {
    config.headers['Authorization'] = token;
  }
  return config;
})

// 返回状态判断(添加响应拦截器)
Vue.http.interceptors.response.use(res => {
  // 对响应数据做些事
  if (!res.data.success) {

  }
  return res
}, error => {
  if (error.response.status === 401) {
    // 401 说明 token 验证失败
    // 可以直接跳转到登录页面，重新登录获取 token
    Vue.prototype.$message('test')
    console.log("login outdate")
    location.href = '/login'
    localStorage.removeItem('authorization')
    localStorage.removeItem('username')
    ElementUI.message.error({
      message: '登录会话过期，请重新登录',
      center: true
    });
  } else if (error.response.status === 500) {
    // 服务器错误
    // do something
    message.error({
      message: '查询失败，请重试',
      center: true
    });
    return Promise.reject(error.response.data)
  }
  // 返回 response 里的错误信息
  return Promise.reject(error.response.data)
})


/* eslint-disable no-new */
//  路由判断登录 根据路由配置文件的参数
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requireAuth)) {
    console.log('需要登录');
    if (localStorage.authorization) {
      next();
    } else {
      next({
        path: '/login'
      })
    }
  } else {
    next();
  }
});
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js